import { useCallback, useEffect, useRef, useState } from "react";

type Options = { min: number; max: number; initial: number };

export const useResizableWidth = ({ min, max, initial }: Options) => {
  const [width, setWidth] = useState(initial);
  const [isResizing, setIsResizing] = useState(false);
  const startX = useRef(0);
  const startWidth = useRef(0);

  useEffect(() => {
    if (!isResizing) return;

    const onMove = (e: MouseEvent) => {
      const next = startWidth.current + e.clientX - startX.current;
      setWidth(Math.min(max, Math.max(min, next)));
    };
    const onUp = () => setIsResizing(false);

    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    return () => {
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };
  }, [isResizing, min, max]);

  const onResizeStart = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      startX.current = e.clientX;
      startWidth.current = width;
      setIsResizing(true);
    },
    [width]
  );

  return { width, isResizing, onResizeStart };
};
